export type PackFile = {
  name: string;
  path: string;
  type: "pdf" | "jpg" | "png" | "txt" | "doc" | "docx" | "epub";
};

function normalizeLocale(locale: string): string {
  const normalized = locale?.toLowerCase().split(/[-_]/)[0] || "en";
  return ["en", "fr", "es", "ar", "de", "it", "nl", "pt", "ru", "sv"].includes(normalized)
    ? normalized
    : "en";
}

export function getPackFiles(locale: string): PackFile[] {
  const map: Record<string, PackFile[]> = {
    en: [
      { name: "Padel_master_the_game.pdf", path: "/packs/en/Padel_master_the_game.pdf", type: "pdf" },
      { name: "Padel_master_the_game.epub", path: "/packs/en/Padel_master_the_game.epub", type: "epub" },
      { name: "Padel_master_the_game.jpg", path: "/packs/en/Padel_master_the_game.jpg", type: "jpg" },
      { name: "Padel_master_the_game.png", path: "/packs/en/Padel_master_the_game.png", type: "png" },
      { name: "LICENSE.txt", path: "/packs/en/LICENSE.txt", type: "txt" },
    ],
    fr: [
      { name: "Padel_Maitrisez_Le_Jeu.pdf", path: "/packs/fr/Padel_Maitrisez_Le_Jeu.pdf", type: "pdf" },
      { name: "Padel_Maitrisez_Le_Jeu.epub", path: "/packs/fr/Padel_Maitrisez_Le_Jeu.epub", type: "epub" },
      { name: "Padel_Maitrisez_Le_Jeu.jpg", path: "/packs/fr/Padel_Maitrisez_Le_Jeu.jpg", type: "jpg" },
      { name: "Padel_Maitrisez_Le_Jeu.png", path: "/packs/fr/Padel_Maitrisez_Le_Jeu.png", type: "png" },
      { name: "LICENCE.txt", path: "/packs/fr/LICENCE.txt", type: "txt" },
    ],
    es: [
      { name: "Pádel_Domina_El_Juego.pdf", path: "/packs/es/Pádel_Domina_El_Juego.pdf", type: "pdf" },
      { name: "Pádel_Domina_El_Juego.epub", path: "/packs/es/Pádel_Domina_El_Juego.epub", type: "epub" },
      { name: "Pádel_Domina_El_Juego.jpg", path: "/packs/es/Pádel_Domina_El_Juego.jpg", type: "jpg" },
      { name: "Pádel_Domina_El_Juego.png", path: "/packs/es/Pádel_Domina_El_Juego.png", type: "png" },
      { name: "LICENCIA.txt", path: "/packs/es/LICENCIA.txt", type: "txt" },
    ],
    ar: [
      { name: "بادل_أتقن_اللعبة.pdf", path: "/packs/ar/بادل_أتقن_اللعبة.pdf", type: "pdf" },
      { name: "بادل_أتقن_اللعبة.epub", path: "/packs/ar/بادل_أتقن_اللعبة.epub", type: "epub" },
      { name: "بادل_أتقن_اللعبة.jpg", path: "/packs/ar/بادل_أتقن_اللعبة.jpg", type: "jpg" },
      { name: "بادل_أتقن_اللعبة.png", path: "/packs/ar/بادل_أتقن_اللعبة.png", type: "png" },
      { name: "ترخيص.txt", path: "/packs/ar/ترخيص.txt", type: "txt" },
    ],
    de: [
      { name: "Padel_Meistern_das_Spiel.pdf", path: "/packs/de/Padel_Meistern_das_Spiel.pdf", type: "pdf" },
      { name: "Padel_Meistern_das_Spiel.epub", path: "/packs/de/Padel_Meistern_das_Spiel.epub", type: "epub" },
      { name: "Padel_Meistern_das_Spiel.jpg", path: "/packs/de/Padel_Meistern_das_Spiel.jpg", type: "jpg" },
      { name: "Padel_Meistern_das_Spiel.png", path: "/packs/de/Padel_Meistern_das_Spiel.png", type: "png" },
      { name: "LIZENZ.txt", path: "/packs/de/LIZENZ.txt", type: "txt" },
    ],
    it: [
      { name: "Padel_Padroneggia_il_Gioco.pdf", path: "/packs/it/Padel_Padroneggia_il_Gioco.pdf", type: "pdf" },
      { name: "Padel_Padroneggia_il_Gioco.epub", path: "/packs/it/Padel_Padroneggia_il_Gioco.epub", type: "epub" },
      { name: "Padel_Padroneggia_il_Gioco.jpg", path: "/packs/it/Padel_Padroneggia_il_Gioco.jpg", type: "jpg" },
      { name: "Padel_Padroneggia_il_Gioco.png", path: "/packs/it/Padel_Padroneggia_il_Gioco.png", type: "png" },
      { name: "LICENZA.txt", path: "/packs/it/LICENZA.txt", type: "txt" },
    ],
    nl: [
      { name: "Padel_Beheers_Het_Spel.pdf", path: "/packs/nl/Padel_Beheers_Het_Spel.pdf", type: "pdf" },
      { name: "Padel_Beheers_Het_Spel.epub", path: "/packs/nl/Padel_Beheers_Het_Spel.epub", type: "epub" },
      { name: "Padel_Beheers_Het_Spel.jpg", path: "/packs/nl/Padel_Beheers_Het_Spel.jpg", type: "jpg" },
      { name: "Padel_Beheers_Het_Spel.png", path: "/packs/nl/Padel_Beheers_Het_Spel.png", type: "png" },
      { name: "LICENTIE.txt", path: "/packs/nl/LICENTIE.txt", type: "txt" },
    ],
    pt: [
      { name: "Padel_Domina_o_jogo.pdf", path: "/packs/pt/Padel_Domina_o_jogo.pdf", type: "pdf" },
      { name: "Padel_Domina_o_jogo.epub", path: "/packs/pt/Padel_Domina_o_jogo.epub", type: "epub" },
      { name: "Padel_Domina_o_jogo.jpg", path: "/packs/pt/Padel_Domina_o_jogo.jpg", type: "jpg" },
      { name: "Padel_Domina_o_jogo.png", path: "/packs/pt/Padel_Domina_o_jogo.png", type: "png" },
      { name: "LICENÇA.txt", path: "/packs/pt/LICENÇA.txt", type: "txt" },
    ],
    ru: [
      { name: "ПАДЛ_ОСВОЙТЕ_ИГРУ.pdf", path: "/packs/ru/ПАДЛ_ОСВОЙТЕ_ИГРУ.pdf", type: "pdf" },
      { name: "ПАДЛ_ОСВОЙТЕ_ИГРУ.epub", path: "/packs/ru/ПАДЛ_ОСВОЙТЕ_ИГРУ.epub", type: "epub" },
      { name: "ПАДЛ_ОСВОЙТЕ_ИГРУ.jpg", path: "/packs/ru/ПАДЛ_ОСВОЙТЕ_ИГРУ.jpg", type: "jpg" },
      { name: "ПАДЛ_ОСВОЙТЕ_ИГРУ.png", path: "/packs/ru/ПАДЛ_ОСВОЙТЕ_ИГРУ.png", type: "png" },
      { name: "ЛИЦЕНЗИЯ.txt", path: "/packs/ru/ЛИЦЕНЗИЯ.txt", type: "txt" },
    ],
    sv: [
      { name: "Padel_Bemästra_spelet.pdf", path: "/packs/sv/Padel_Bemästra_spelet.pdf", type: "pdf" },
      { name: "Padel_Bemästra_spelet.epub", path: "/packs/sv/Padel_Bemästra_spelet.epub", type: "epub" },
      { name: "Padel_Bemästra_spelet.jpg", path: "/packs/sv/Padel_Bemästra_spelet.jpg", type: "jpg" },
      { name: "Padel_Bemästra_spelet.png", path: "/packs/sv/Padel_Bemästra_spelet.png", type: "png" },
      { name: "LICENS.txt", path: "/packs/sv/LICENS.txt", type: "txt" },
    ],
  };

  return map[normalizeLocale(locale)] ?? map.en;
}
